import * as d3 from 'd3';
import * as c3 from 'c3';
import Chart from 'src/javascripts/components/Chart';
import Spinner from 'src/javascripts/components/utilities/Spinner';

export default class DonutChart extends Chart {

  getData() {

    // Set a spinner to indicate chart loading
    Spinner(this.el);

    // Get data from element or api
    let dataStr = this.el.attr('data-chart-data');
    let data = dataStr ? JSON.parse(dataStr) : undefined;
    if (typeof data !== 'undefined') { return data; }

    // Set url
    let url = this.el.attr('data-api-url');
    return $.getJSON(url);

  }

  render(data) {

    // Set id
    let chartId = this.el.attr('id');

    // Set colors key
    let colorsKey = {
      "Inclusive economies": "#f2d4b5",
      "Life on earth": "#dbe4be",
      "Peace and justice": "#D5E174", 
      "Quality education": "#ffe6b3", 
      "Innovation": "#ffc6b3", 
      "Climate action": "#bfe5c7", 
      "Gender equality": "#d1d1e0", 
      "Sustainable resource use": "#d1e0e0", 
      "Water and sanitation": "#B6D0F2", 
      "Health and well-being": "#bef4f4"
    };

    // Render chart
    var chart = c3.generate({
      bindto: '#' + chartId,
      data: {
        columns: data.data,
        type: 'donut',
        color: function (color, d) {
          return colorsKey[d];
        }
      },
      donut: {
        width: 70,
        label: {show: false}
      },
      point: {show: false},
    });

    return chart;

  }


};
